<template>
  <section>
    <h2 class="sponsors-component sz-red--text f-24 font-weight-medium text-center mb-5">
      {{ $t('home.sponsors') }}
    </h2>

    <div class="sponsors-component__list">
      <div
        v-for="(sponsor, index) in sponsorsList"
        :key="index"
        class="sponsors-component__sponsor"
      >
        <img
          :src="sponsor.imageUrl"
          :alt="sponsor.alt"
          height="85"
        >
        <v-divider
          class="sponsors-component__divider d-none d-sm-inline-flex"
          vertical
          opacity="1"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { Sponsor } from '@/types';

const sponsorsList: Sponsor[] = [
    { alt: 'BNP Paribas', imageUrl: require('@/assets/images/sponsors/BNP_Paribas_logo.png?as=webp') },
    { alt: 'T-Mobile', imageUrl: require('@/assets/images/sponsors/timo.png?as=webp') }
];
</script>
<style lang="scss">
.sponsors-component {
  &__list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 32px;
  }

  &__sponsor {
    height: 85px;

    &:last-child {
      .sponsors-component__divider {
        display: none !important; // override vuetify
      }
    }
  }

  &__divider {
    width: 2px;
    height: 85px;
    margin: 0 16px;
    color: #d3d3d3
  }
}
</style>
